import { FC } from 'react';
import { ColorPicker, Input } from '@/components/ui';

interface BrandingSectionProps {
  color1: string;
  color2: string;
  color3: string;
  backgroundColor: string;
  fontForText: string;
  brandHandle: string;
  brandName: string;
  onColor1Change: (value: string) => void;
  onColor2Change: (value: string) => void;
  onColor3Change: (value: string) => void;
  onBackgroundColorChange: (value: string) => void;
  onFontChange: (value: string) => void;
  onBrandHandleChange: (value: string) => void;
  onBrandNameChange: (value: string) => void;
  shouldShowBackgroundColor: boolean;
  shouldShowBrandHandle: boolean;
  shouldShowBrandName: boolean;
  shouldShowColor3?: boolean;
  disabled?: boolean;
}

export const BrandingSection: FC<BrandingSectionProps> = ({
  color1,
  color2,
  color3,
  backgroundColor,
  fontForText,
  brandHandle,
  brandName,
  onColor1Change,
  onColor2Change,
  onColor3Change,
  onBackgroundColorChange,
  onFontChange,
  onBrandHandleChange,
  onBrandNameChange,
  shouldShowBackgroundColor,
  shouldShowBrandHandle,
  shouldShowBrandName,
  shouldShowColor3 = false,
  disabled = false,
}) => {
  return (
    <>
      <div className={disabled ? 'opacity-60 pointer-events-none' : ''}>
        <ColorPicker
          label="Color 1"
          value={color1}
          onChange={disabled ? () => {} : onColor1Change}
          placeholder="#e92d4b"
        />
      </div>

      <div className={disabled ? 'opacity-60 pointer-events-none' : ''}>
        <ColorPicker
          label="Color 2"
          value={color2}
          onChange={disabled ? () => {} : onColor2Change}
          placeholder="#ffffff"
        />
      </div>

      {shouldShowColor3 && (
        <div className={disabled ? 'opacity-60 pointer-events-none' : ''}>
          <ColorPicker
            label="Color 3"
            value={color3}
            onChange={disabled ? () => {} : onColor3Change}
            placeholder="#000000"
          />
        </div>
      )}

      {shouldShowBackgroundColor && (
        <div className={disabled ? 'opacity-60 pointer-events-none' : ''}>
          <ColorPicker
            label="Background Color"
            value={backgroundColor}
            onChange={disabled ? () => {} : onBackgroundColorChange}
            placeholder="#0B1325"
          />
        </div>
      )}

      <Input
        label="Font for Text"
        value={fontForText}
        onChange={(e) => onFontChange(e.target.value)}
        placeholder="Enter font name (e.g., gils-sal)"
        fullWidth
        disabled={disabled}
      />

      {shouldShowBrandHandle && (
        <Input
          label="Brand Handle"
          value={brandHandle}
          onChange={(e) => onBrandHandleChange(e.target.value)}
          placeholder="@reallygreatsite"
          fullWidth
          disabled={disabled}
        />
      )}

      {shouldShowBrandName && (
        <Input
          label="Brand Name"
          value={brandName}
          onChange={(e) => onBrandNameChange(e.target.value)}
          placeholder="Carion Analytics"
          fullWidth
          disabled={disabled}
        />
      )}
    </>
  );
};

